import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { LOGO_URL, WHATSAPP_DISPLAY, BRAND_EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL, buildWhatsAppLink } from "../lib/api";

export default function Footer() {
  return (
    <footer className="bg-[#2D004F] text-[#F3EFEA] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <img src={LOGO_URL} alt="I'm Ube" className="h-20 md:h-24 w-auto object-contain bg-white/95 rounded-2xl p-2" />
          </div>
          <p className="text-[#F3EFEA]/70 max-w-md leading-relaxed">
            India's No. 1 wholesale supplier of premium Ube (purple yam) powder. Trusted by cafes, bakeries, ice-cream brands, HORECA & D2C across the country.
          </p>
        </div>
        <div>
          <h4 className="font-display text-lg text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-[#F3EFEA]/80">
            <li><Link to="/" className="hover:text-[#D4AF37]" data-testid="footer-home">Home</Link></li>
            <li><Link to="/recipes" className="hover:text-[#D4AF37]" data-testid="footer-recipes">Recipes</Link></li>
            <li><Link to="/blogs" className="hover:text-[#D4AF37]" data-testid="footer-blogs">Blogs</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37]" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-lg text-white mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-[#F3EFEA]/80">
            <li className="flex items-center gap-2">
              <MessageCircle size={16} className="text-[#D4AF37]" />
              <a href={buildWhatsAppLink()} target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-whatsapp">{WHATSAPP_DISPLAY}</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-[#D4AF37]" />
              <a href={`mailto:${BRAND_EMAIL}`} className="hover:text-white" data-testid="footer-email">{BRAND_EMAIL}</a>
            </li>
            <li className="flex items-center gap-2">
              <Instagram size={16} className="text-[#D4AF37]" />
              <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-instagram">{INSTAGRAM_HANDLE}</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#F3EFEA]/60">
          <span>© {new Date().getFullYear()} I'm Ube. All rights reserved.</span>
          <span>Bulk Ube India · Wholesale Ube Powder · HORECA Supplier · Surat, Gujarat</span>
        </div>
      </div>
    </footer>
  );
}
